function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun-document-169319",
  transform: "translate(-0.165 0.257)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3935",
  "data-name": "Path 3935",
  d: "M144.77,34.7V219.384h92a43.641,43.641,0,0,1-2.85-4.5H149.284V39.2H280.267V151.354a43.1,43.1,0,0,1,4.516,1.065V34.7Z",
  transform: "translate(-144.605 -34.956)",
  fill: "#f37320",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3936",
  "data-name": "Path 3936",
  d: "M229.67,302.45v4.5h71.385v-4.5Z",
  transform: "translate(-195.505 -194.702)",
  fill: "#f37320",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3937",
  "data-name": "Path 3937",
  d: "M229.68,346.19v4.5h61.369a43.8,43.8,0,0,1,4.89-4.5Z",
  transform: "translate(-195.511 -220.84)",
  fill: "#f37320",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3938",
  "data-name": "Path 3938",
  d: "M229.68,389.93v4.5H281a43.372,43.372,0,0,1,1.563-4.5Z",
  transform: "translate(-195.511 -246.978)",
  fill: "#f37320",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3939",
  "data-name": "Path 3939",
  d: "M405.067,337.3a37.826,37.826,0,1,0,26.748,11.081A37.824,37.824,0,0,0,405.067,337.3Zm-7.658,24.308h15.317v7.737h5.863v19.305H391.547V369.346h5.863v-7.737Zm3.727,3.729v4.01H409v-4.01Z",
  transform: "translate(-277.714 -215.528)",
  fill: "#f37320"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3940",
  "data-name": "Path 3940",
  d: "M229.67,302.45v4.5h71.385v-4.5Z",
  transform: "translate(-195.505 -212.303)",
  fill: "#f37320",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3941",
  "data-name": "Path 3941",
  d: "M229.67,302.45v4.5h71.385v-4.5Z",
  transform: "translate(-195.505 -229.904)",
  fill: "#f37320",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3942",
  "data-name": "Path 3942",
  d: "M229.67,302.45v4.5h71.385v-4.5Z",
  transform: "translate(-195.5 -247.505)",
  fill: "#f37320",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3943",
  "data-name": "Path 3943",
  d: "M229.67,302.45v4.5h71.385v-4.5Z",
  transform: "translate(-195.5 -265.106)",
  fill: "#f37320",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3944",
  "data-name": "Path 3944",
  d: "M229.67,302.45v4.5h71.385v-4.5Z",
  transform: "translate(-195.5 -282.707)",
  fill: "#f37320",
  fillRule: "evenodd"
}));

function SvgClosureDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165.014,
    height: 197.686,
    viewBox: "0 0 165.014 197.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosureDocument);
export default __webpack_public_path__ + "static/media/closureDocument.097ebd0842c858dc40b11c34ba83f31d.svg";
export { ForwardRef as ReactComponent };